/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {
  MouseEvent,
  ReactNode
} from 'react';
import {JobStatus} from '@ion/core/src/types/entities';
import {IonDialog} from '@ion/dls/src/components/dialogs/IonDialog';
import {getTaskNickName} from './TaskStatusGridHelpers';

export interface JobViewDialogProps {
  onCloseDialog?: (e: MouseEvent) => void;
  children: ReactNode;
  open: boolean;
  jobStatus: JobStatus;
}

/**
 *
 * ```typescript
 *
 * import {JobViewDialog} from '@ion/dls/src/editors/';
 *
 * <JobViewDialog open={open}
 *   onCancelDialog={onCancelDialog}>
 *   <Component />
 * </JobViewDialog>
 *
 * ```
 *
 */
export const JobViewDialog = ({
  children,
  onCloseDialog,
  open,
  jobStatus
}: JobViewDialogProps) => (
  <IonDialog open={open}
    title={getTaskNickName(jobStatus)}
    onClose={onCloseDialog}>
    {children}
  </IonDialog>
);

export default JobViewDialog;
